import React from "react";
import Popupz from "../../atoms/Popupz";
import Buttonz from "../../atoms/Buttonz";
import SvgIcn from "../../../data/IconCompo";

export function SettingEditPopup({}) {
  const onClose = () => {
    if (localStorage.getItem("token")) {
      window.location.reload();
    } else {
      window.location = "top";
    }
  };
  return (
    <Popupz onClose={onClose} className="password-reset-success-popup">
      <div className="password-reset-success-content">
        <div className="icon-wrapper">
          <SvgIcn name="chara00" />
        </div>
        <h2 className="password-reset-success-title">Profle Edit</h2>
        <p className="password-reset-success-description">Profile has been successfully updated</p>
        <div className="password-reset-success-button">
          <Buttonz 
          iconR={"close"}
          onClick={onClose}
          >Close
          </Buttonz>
        </div>
      </div>
    </Popupz>
  );
}
export function SettingEmailPopup({}) {
  const onClose = () => {
    window.location.reload();
  };
  return (
    <Popupz onClose={onClose} className="password-reset-success-popup">
      <div className="password-reset-success-content">
        <div className="icon-wrapper">
          <SvgIcn name="success" />
        </div>
        <h2 className="password-reset-success-title">Email popup</h2>
        <p className="password-reset-success-description">asdf</p>
        <div className="password-reset-success-button">
          <Buttonz onClick={onClose}>Close</Buttonz>
        </div>
      </div>
    </Popupz>
  );
}
export function SettingPasswordPopup({}) {
  const onClose = () => {
    window.location.reload();
  };
  return (
    <Popupz onClose={onClose} className="password-reset-success-popup">
      <div className="password-reset-success-content">
        <div className="icon-wrapper">
          <SvgIcn name="success" />
        </div>
        <h2 className="password-reset-success-title">Password</h2>
        <p className="password-reset-success-description">
          Your password has been updated successfully.
        </p>
        <div className="password-reset-success-button">
          <Buttonz onClick={onClose}>Close</Buttonz>
        </div>
      </div>
    </Popupz>
  );
}
